module.exports = __webpack_public_path__ + "assets/7034b722b89981df91f32014e76d8bd9.png";